"use client";

import Link from "next/link";
import { FaRegUser } from "react-icons/fa";
import { PiTelegramLogo } from "react-icons/pi";
import { MdMailOutline } from "react-icons/md";
import Image from "next/image";
import { IoMdClose, IoMdSunny } from "react-icons/io";
import { IoMoon } from "react-icons/io5";
import { useTheme } from "@/contexts/ThemeContext";

const MobileMenuDrawer = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: any;
}) => {
  const { theme, setTheme } = useTheme();
  return (
    <div
      className={`fixed top-0 h-dvh w-full bg-bg15 transition-all duration-300 z-10 px-5 pb-5 pt-12 flex flex-col overflow-y-scroll
      ${open ? "right-0" : "-right-[200%]"}`}
    >
      <IoMdClose
        className="absolute top-[52px] right-5 text-text1 text-[24px]"
        onClick={() => setOpen(false)}
      />
      <menu>
        <li className="size-fit">
          <Link
            className="py-1.5 block"
            href="/"
            onClick={() => setOpen(false)}
          >
            <span className="font-bold text-white text-xs">Home</span>
          </Link>
        </li>
        <li className="size-fit">
          <Link
            className="py-1.5 block"
            href="/#about"
            onClick={() => setOpen(false)}
          >
            <span className="font-bold text-white text-xs">About Us</span>
          </Link>
        </li>
        <li className="size-fit">
          <Link
            className="py-1.5 block"
            href="/#commission"
            onClick={() => setOpen(false)}
          >
            <span className="font-bold text-white text-xs">Commission</span>
          </Link>
        </li>
        <li className="size-fit">
          <Link
            className="py-1.5 block"
            href="/help-center"
            onClick={() => setOpen(false)}
          >
            <span className="font-bold text-white text-xs">Help Center</span>
          </Link>
        </li>
        <li className="size-fit">
          <Link
            className="py-1.5 block"
            href="/#contact-us"
            onClick={() => setOpen(false)}
          >
            <span className="font-bold text-white text-xs">Contact Us</span>
          </Link>
        </li>
      </menu>

      <hr className="my-3.5 opacity-10 text-text1" />

      <div className="flex items-center justify-center gap-20">
        <Link
          target="_blank"
          rel="noopener noreferrer nofollow"
          href="/affiliate"
        >
          <FaRegUser className="text-text1 text-xl" />
        </Link>
        <Link target="_blank" rel="noopener noreferrer nofollow" href="mailto:support.bd@dalalaff.com">
          <MdMailOutline className="text-text1 text-2xl" />
        </Link>
        <Link
          target="_blank"
          rel="noopener noreferrer nofollow"
          href="https://t.me/dalal_official"
        >
          <PiTelegramLogo className="text-text1 text-xl" />
        </Link>
      </div>

      <hr className="my-3.5 opacity-10 text-text1" />
      <div className="space-y-4">
        <p className="text-xs text-white">Language</p>
        <div className="my-2.5 size-fit mx-auto">
          <div className="py-2.5 w-full flex items-center gap-10">
            <Image
              width="46"
              height="30"
              src="/assets/bangladesh.webp"
              alt="Bangladesh flag"
              className="object-cover h-6 lg:h-7.5 w-10 lg:w-11.5 rounded-full"
            ></Image>
            <button className="font-bold lg:text-base text-xs border rounded-md border-white/10">
              <Link
                className="font-bold text-text1 text-base py-1 px-2.5 block "
                href="/bn-en"
              >
                English
              </Link>
            </button>
            <button className="font-bold lg:text-base text-xs border rounded-md border-transparent">
              <Link
                className="font-bold text-text1 text-base py-1 px-2.5 block "
                href="/bn"
              >
                বাংলা
              </Link>
            </button>
          </div>
        </div>
      </div>

      <div className="mt-auto space-y-5">
        <p className="text-xs text-white">Theme</p>
        <div className="flex items-center text-lg relative">
          <div
            className={`w-1/2 lg:w-10 h-7.5 grid place-items-center rounded-2xl absolute transition-all duration-300 bg-bg2 ${
              theme === "dark" ? "left-1/2 lg:left-10" : "left-0"
            }`}
          ></div>
          <button
            onClick={() => {
              setTheme("light");
              setOpen(false);
            }}
            className={`w-1/2 lg:w-10 h-7.5 grid place-items-center rounded-2xl transition-all relative ${
              theme === "light" ? "bg-bg2" : ""
            }`}
            title="Light Mode"
          >
            <IoMdSunny className="text-text1" />
          </button>
          <button
            onClick={() => {
              setTheme("dark");
              setOpen(false);
            }}
            className={`w-1/2 lg:w-10 h-7.5 grid place-items-center rounded-2xl transition-all relative ${
              theme === "dark" ? "bg-bg2" : ""
            }`}
            title="Dark Mode"
          >
            <IoMoon className="text-text1 text-sm" />
          </button>
        </div>
      </div>
      <hr className="my-5.5 opacity-10 text-text1" />
      <Link
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="text-sm/6 lg:text-base/6 font-bold text-text1 w-full rounded-full bg-primary flex items-center justify-center py-1.5 relative overflow-hidden"
        href="https://baghpartners.com/page/affiliate/login.jsp"
      >
        Login/Register
        <span className="shine-effect shine-orange" aria-hidden="true"></span>
      </Link>
    </div>
  );
};

export default MobileMenuDrawer;
